import {
	isStreamAutoActionApproval,
	type StreamAutoActionApproval,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { Trace } from '@atlassian/conversation-assistant-store/controllers/chat/types';

type ValidAutoActionApproval = {
	kind: 'valid';
	trace: Trace;
	analytics: {
		action: 'received' | 'fallback';
		attributes: {
			status: StreamAutoActionApproval['message']['status'];
			source: string;
			riskCategory: string;
			policyVersion: string;
			latencyMs: number;
		};
	};
};

type AutoActionApprovalNormalizationResult =
	| { kind: 'not-auto-action-approval' }
	| { kind: 'malformed' }
	| ValidAutoActionApproval;

export const normalizeAutoActionApprovalStreamMessage = (
	streamMessage: unknown,
): AutoActionApprovalNormalizationResult => {
	if (
		typeof streamMessage !== 'object' ||
		streamMessage === null ||
		!('type' in streamMessage) ||
		streamMessage.type !== 'AUTO_ACTION_APPROVAL'
	) {
		return { kind: 'not-auto-action-approval' };
	}

	if (!isStreamAutoActionApproval(streamMessage)) {
		return { kind: 'malformed' };
	}

	const { message, millisOffset } = streamMessage;
	const isFallback =
		message.status === 'AUTO_APPROVED_REQUIRES_HUMAN' || message.status === 'REQUIRES_HUMAN';

	return {
		kind: 'valid',
		trace: {
			messageTemplate: 'AUTO_ACTION_APPROVAL',
			messageContent: message.content || message.action_display_name,
			status: message.status === 'REVIEWING' ? 'loading' : 'success',
		},
		analytics: {
			action: isFallback ? 'fallback' : 'received',
			attributes: {
				status: message.status,
				source: message.source,
				riskCategory: message.risk_category,
				policyVersion: message.policy_version,
				latencyMs: millisOffset,
			},
		},
	};
};
